<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Finance industry solutions development and design",
    "pageDesc":"From insurance to banking and stock market, we develop and design mobile apps, websites and software that add automty to the finance process.",
    "mantra":"Soaring digital |and finance.",
    "mantraDesc":"Whether banking, insurance or stock market, we provide support in the finance sector to add more autonomy to its processes and create innovative business models.",
    "sec1":"Helping financial institutions thrive in the digital era.",
    "sec1Items":{
      "1":{
        "title":"Banks",
        "desc":"Whether brand identity development or software design, we support banks in booking a unique position in their target audience minds."
      },
      "2":{
        "title":"Insurance companies",
        "desc":"Helping insurance companies with AI features and technologies that assists their prediction and estimation."
      },
      "3":{
        "title":"Stock markets",
        "desc":"Providing solutions for stock markets that lets audience have instance mirror of the trends and downs. "
      }
    },
    "sec2":"Custom solutions for financial needs.",
    "sec2Items":{
      "1":{
        "title":"Mobile apps",
        "desc":"Developing mobile apps that makes it easier for clients to see their bank account or redeem insurance fees."
      },
      "2":{
        "title":"Web apps",
        "desc":"Creating platforms that support the initial cases of the business and make your online presence more professional."
      },
      "3":{
        "title":"Software systems",
        "desc":"Building systems that scales with your operations growth and lets you connect your branches altogether."
      }
    },
    "sec3Items":{
      "1":{
        "title":"Growth in revenue",
        "desc":"Reach more of your targeted clients and close deals faster by relying on technology services."
      },
      "2":{
        "title":"Improve performance",
        "desc":"Accelerate your day-to-day activities through software solutions that makes your life easier."
      },
      "3":{
        "title":"Enhance Customer experience",
        "desc":"Provide a more luxurious experience by adding the value of mobility to your high end finance solutions."
      }
    },
    "cta":"Let’s plan your <br> finance solution."
  },
  "ar": {
    "pageTitle":"تصميم وبرمجة مواقع وتطبيقات الخدمات المالية",
    "pageDesc":"نقوم بتصميم وبرمجة تطبيقات الجوال ومواقع الويب والبرامج التي تساعد على أتمتة وأداء العمليات المالية من التأمين إلى الخدمات المصرفية وسوق الأوراق المالية.",
    "mantra":"ادعم خدماتك المالية |بالعمليات الرقمية.",
    "mantraDesc":"سواء كان بنكًا أو تأمينًا أو سوق للأوراق المالية، فإننا نقدم الدعم في القطاع المالي بأكمله؛ لإضافة المزيد من الاستقلالية إلى عملياته وإنشاء نماذج أعمال مبتكرة.",
    "sec1":"نساعد المؤسسات المالية على الازدهار في العصر الرقمي.",
    "sec1Items":{
      "1":{
        "title":"البنوك",
        "desc":"سواء كان تطوير هوية العلامة التجارية أو تصميم البرامج، فإننا ندعم البنوك في حجز مكانة فريدة في أذهان الجمهور المستهدف."
      },
      "2":{
        "title":"شركات التأمين",
        "desc":"نعمل على مساعدة شركات التأمين من خلال مميزات وتقنيات الذكاء الاصطناعي التي تساعد على التنبؤ وتجهيز أعمالك."
      },
      "3":{
        "title":"سوق الأسهم",
        "desc":"نعمل على توفير حلول أسواق الأوراق المالية التي تتيح للجمهور أن يكون له نسخة طبق الأصل عن جميع الأخبار حول صعود وهبوط الأسهم."
      }
    },
    "sec2":"حلول مصممة خصيصًا من أجل دعم الاحتياجات المالية.",
    "sec2Items":{
      "1":{
        "title":"تطبيقات الويب",
        "desc":"نعمل على إنشاء منصات تدعم الحالات الأولية للعمل وتجعل تواجدك على الإنترنت أكثر احترافية وسهولة."
      },
      "2":{
        "title":"تطبيقات الجوال",
        "desc":"نساعدك على تطوير تطبيقات الجوال التي تسهل على العملاء رؤية حساباتهم المصرفية أو استرداد رسوم التأمين."
      },
      "3":{
        "title":"أنظمة البرامج",
        "desc":"نعمل على بناء الأنظمة التي تتناسب مع نمو عملياتك وتتيح لك توصيل فروعك مع بعضها البعض بالكامل."
      }
    },
    "sec3Items":{
      "1":{
        "title":"النمو في الإيرادات",
        "desc":"يمكنك الوصول إلى المزيد من العملاء المستهدفين وإغلاق الصفقات بشكل أسرع من خلال الاعتماد على خدمات التكنولوجيا المختلفة."
      },
      "2":{
        "title":"تحسين الأداء",
        "desc":"اعمل على تسريع الأنشطة اليومية الخاصة بك  من خلال حلول البرمجيات التي تجعل حياتك أسهل وأبسط."
      },
      "3":{
        "title":"تعزيز تجربة العملاء",
        "desc":"وفر تجربة أكثر فاعلية وسهولة عن طريق إضافة قيمة التنقل إلى حلول التمويل الراقية التي تمنح المستخدم تجربة سهلة ومألوفة."
      }
    },
    "cta":"دعنا نخطط <br> لحلولك المالية"
  }
}
</i18n>
